export const VOUCHER_QUERY_NAME = 'promocode';
